import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="border-t border-surface-border bg-surface py-8 text-sm">
      <div className="container-content">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          <div>
            <h3 className="font-serif text-sm font-semibold mb-2 text-text-primary">Über diese Plattform</h3>
            <p className="text-text-secondary leading-relaxed">
              Geschlossene Auktionsplattform für Patente. Zugang nur per Einladung.
            </p>
          </div>
          <div>
            <h3 className="font-serif text-sm font-semibold mb-2 text-text-primary">Rechtliches</h3>
            <ul className="space-y-1">
              <li><Link to="/impressum" className="text-text-secondary hover:text-text-primary no-underline">Impressum</Link></li>
              <li><Link to="/datenschutz" className="text-text-secondary hover:text-text-primary no-underline">Datenschutz</Link></li>
              <li><Link to="/agb" className="text-text-secondary hover:text-text-primary no-underline">AGB / Auktionsbedingungen</Link></li>
              <li><Link to="/compliance" className="text-text-secondary hover:text-text-primary no-underline">Compliance-Richtlinie</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-serif text-sm font-semibold mb-2 text-text-primary">Kontakt</h3>
            <Link to="/kontakt" className="text-text-secondary hover:text-text-primary no-underline">Kontaktformular</Link>
            <p className="text-text-muted mt-2">
              Diese Webseite verwendet ausschließlich technisch notwendige Cookies.
            </p>
          </div>
        </div>
        <div className="mt-6 pt-4 border-t border-surface-border text-center text-text-muted text-xs">
          &copy; {new Date().getFullYear()} Patent-Auktionsplattform. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
}
